// client/src/pages/CheckoutCancel.jsx
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Button,
  Chip,
  Container,
  Divider,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

export default function CheckoutCancel() {
  return (
    <Container sx={{ py: 6 }}>
      <Grid container spacing={4}>
        {/* Left: Message */}
        <Grid size={{ xs: 12, md: 8 }}>
          <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
            <Stack direction="row" alignItems="center" spacing={1} mb={1}>
              <CancelOutlinedIcon color="error" />
              <Typography variant="h4" fontWeight={800}>
                Checkout canceled
              </Typography>
            </Stack>

            <Typography color="text.secondary" sx={{ mb: 2 }}>
              You haven’t been charged. Your cart items are still saved, so you
              can try again anytime.
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{ mb: 1 }}
            >
              <Chip size="small" label="Tip" />
              <Typography variant="body2" color="text.secondary">
                If you ran into an issue, you can update your shipping details
                or payment method on the next attempt.
              </Typography>
            </Stack>

            <Box mt={3} display="flex" gap={1} flexWrap="wrap">
              <Button component={RouterLink} to="/?cart=1" variant="contained">
                Back to cart
              </Button>
              <Button
                variant="outlined"
                component={RouterLink}
                to="/products"
                sx={{ borderRadius: 2, fontWeight: 700 }}
              >
                Continue shopping
              </Button>
            </Box>
          </Paper>
        </Grid>

        {/* Right: Summary/Help */}
        <Grid size={{ xs: 12, md: 4 }}>
          <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
            <Typography variant="h6" fontWeight={800} gutterBottom>
              Need help?
            </Typography>
            <Typography variant="body2" color="text.secondary">
              If you believe this was a mistake or your card was declined, try
              again with a different payment method. You can also contact us
              from the <RouterLink to="/contact">Contact</RouterLink> page.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
